export default {
  "alignLeft": "rjuXJ",
  "textWrapNowrap": "_0aiuM",
  "alignRight": "DLOUz",
  "alignCenter": "G5lBZ",
  "sizeFullWidth": "_6W60U",
  "renderedInTable": "PWoL4",
  "sizeOriginal": "I2OKC",
  "sizeContent": "_2ncZP",
  "sizeSmall": "X-Lq7",
  "sizeSmallCenter": "_1Xr3U",
  "flex": "bB3EJ",
  "atomic": "R7vEN",
  "embed": "Kb35a",
  "horizontalScrollbar": "d-ZId",
  "pluginContainerMobile": "KrAdJ"
};